/*
	the routes that scripts/prerender.mjs writes as static HTML at build time, with their head metadata.

	its own module, apart from entry-server.tsx, so the client can read the titles (static-page.tsx
	sets document.title from them on client-side navigation) without pulling in react-dom/server.
*/

//	the <title> in index.html, which every route without its own title keeps
export const siteTitle = 'hangaround.live'

export interface PrerenderRoute {
	path: string
	//	relative to the published folder. Cloudflare Pages serves `faq.html` at `/faq`.
	file: string
	//	undefined keeps the head from index.html, which is written for `/`
	title?: string
	description?: string
}

export const prerenderRoutes: PrerenderRoute[] = [
	{ path: '/', file: 'index.html' },
	{
		path: '/faq',
		file: 'faq.html',
		title: 'FAQ | hangaround.live',
		description: 'Frequently asked questions about hangaround.live: how the small neighborhood chat groups work, how it differs from social networks and friend-finder apps, and whether it is free.',
	},
	{
		path: '/terms',
		file: 'terms.html',
		title: 'Terms of Service | hangaround.live',
		description: 'The Terms of Service of hangaround.live.',
	},
	{
		path: '/privacy',
		file: 'privacy.html',
		title: 'Privacy Policy | hangaround.live',
		description: 'The Privacy Policy of hangaround.live: what information we collect, how we use, store and share it, and your data protection rights.',
	},
]
